module.exports = __webpack_public_path__ + "static/img/s52.f07233f3.png";